/* wf-lightbox – produktsidans bildvisare i husstil (2026-09-15). Ersätter Sense product-modal (helsides vit modal).
   Tar över klick på bild/zoom-knapp i galleriet (.wf-pdp), visar en bild i taget på mörk botten med pilar, räknare,
   tumnaglar, svep, pinch- och klickzoom, Esc/klick utanför stänger. Vid stängning visas den senast visade bilden i galleriet. */
(function () {
  if (window.wfLightbox) return;
  window.wfLightbox = 1;
  var lb, stage, img, vid, cnt, thumbs, items = [], idx = 0, lastFocus = null, gallerySection = '';
  var scale = 1, tx = 0, ty = 0, pinch = null, drag = null, swipe = null, suppressZoomClick = false;
  var I18N = { sv: ['Stäng', 'Föregående bild', 'Nästa bild', 'Bild'], en: ['Close', 'Previous image', 'Next image', 'Image'], fr: ['Fermer', 'Image précédente', 'Image suivante', 'Image'], es: ['Cerrar', 'Imagen anterior', 'Imagen siguiente', 'Imagen'], de: ['Schließen', 'Vorheriges Bild', 'Nächstes Bild', 'Bild'], it: ['Chiudi', 'Immagine precedente', 'Immagine successiva', 'Immagine'] };
  var lang = (document.documentElement.lang || 'sv').slice(0, 2).toLowerCase();
  var T = I18N[lang] || I18N.sv;

  function big(src) { return src.replace(/([?&])width=\d+/, '$1width=1800').replace(/(_\d+x\d*|_\d*x\d+)(\.[a-z]+)(\?|$)/i, '$2$3'); }
  function collect(root) {
    var list = [];
    root.querySelectorAll('.product__media-list .product__media-item').forEach(function (li) {
      if (li.querySelector('product-model')) return; /* 3D lämnas åt temat */
      var dm = li.querySelector('deferred-media');
      var im = li.querySelector('.product__media img, .deferred-media__poster img');
      if (dm) {
        var tpl = dm.querySelector('template');
        if (!tpl) return;
        list.push({ type: 'video', html: tpl.innerHTML, alt: im ? (im.alt || '') : '', id: li.getAttribute('data-media-id') || '', thumb: im ? (im.currentSrc || im.src) : '' });
        return;
      }
      if (!im) return;
      list.push({ type: 'image', src: big(im.currentSrc || im.src), alt: im.alt || '', id: li.getAttribute('data-media-id') || '', thumb: (im.currentSrc || im.src) });
    });
    return list;
  }
  function build() {
    lb = document.createElement('div');
    lb.className = 'wf-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', T[3]);
    lb.hidden = true;
    lb.innerHTML =
      '<div class="wf-lb__backdrop" data-wf-lb-close></div>' +
      '<button type="button" class="wf-lb__btn wf-lb__close" data-wf-lb-close aria-label="' + T[0] + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button type="button" class="wf-lb__btn wf-lb__nav wf-lb__prev" data-wf-lb-prev aria-label="' + T[1] + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="wf-lb__btn wf-lb__nav wf-lb__next" data-wf-lb-next aria-label="' + T[2] + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="wf-lb__stage"><img class="wf-lb__img" alt="" draggable="false"><div class="wf-lb__video" hidden></div></div>' +
      '<div class="wf-lb__bar"><span class="wf-lb__count" aria-live="polite"></span><div class="wf-lb__thumbs" role="list"></div></div>';
    document.body.appendChild(lb);
    stage = lb.querySelector('.wf-lb__stage');
    img = lb.querySelector('.wf-lb__img');
    vid = lb.querySelector('.wf-lb__video');
    cnt = lb.querySelector('.wf-lb__count');
    thumbs = lb.querySelector('.wf-lb__thumbs');
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-wf-lb-close]')) { close(); return; }
      if (e.target.closest('[data-wf-lb-prev]')) { go(-1); return; }
      if (e.target.closest('[data-wf-lb-next]')) { go(1); return; }
      var t = e.target.closest('[data-wf-lb-idx]');
      if (t) { show(parseInt(t.getAttribute('data-wf-lb-idx'), 10)); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowLeft') { go(-1); }
      else if (e.key === 'ArrowRight') { go(1); }
    });
    /* klick-/dubbeltryckszoom – lyssna på stage, inte img: stage.setPointerCapture nedan gör att click får stage som target, så en lyssnare på img träffas aldrig (bugg 2026-10-19) */
    stage.addEventListener('click', function (e) {
      if (lb.classList.contains('wf-lb--video')) return;
      if (suppressZoomClick) { suppressZoomClick = false; return; }
      if (drag && drag.moved) return;
      if (scale > 1) { setZoom(1, 0, 0); }
      else {
        var r = img.getBoundingClientRect();
        var cx = (e.clientX - r.left) / r.width - 0.5, cy = (e.clientY - r.top) / r.height - 0.5;
        setZoom(2.2, -cx * r.width * 1.2, -cy * r.height * 1.2);
      }
    });
    /* pekare: svep (ozoomad) eller panorering (zoomad), pinch med två fingrar */
    var pts = {};
    stage.addEventListener('pointerdown', function (e) {
      if (lb.classList.contains('wf-lb--video')) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var keys = Object.keys(pts);
      if (keys.length === 2) {
        var a = pts[keys[0]], b = pts[keys[1]];
        pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), s: scale };
        swipe = null; drag = null;
      } else if (scale > 1) {
        drag = { x: e.clientX, y: e.clientY, tx: tx, ty: ty, moved: false };
      } else {
        swipe = { x: e.clientX, y: e.clientY, t: Date.now() };
      }
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    });
    stage.addEventListener('pointermove', function (e) {
      if (lb.classList.contains('wf-lb--video')) return;
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var keys = Object.keys(pts);
      if (pinch && keys.length === 2) {
        var a = pts[keys[0]], b = pts[keys[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        setZoom(Math.min(4, Math.max(1, pinch.s * d / pinch.d)), tx, ty);
        e.preventDefault();
      } else if (drag) {
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(dx) + Math.abs(dy) > 4) drag.moved = true;
        setZoom(scale, drag.tx + dx, drag.ty + dy);
        e.preventDefault();
      }
    });
    function up(e) {
      delete pts[e.pointerId];
      if (Object.keys(pts).length < 2) pinch = null;
      if (drag && Object.keys(pts).length === 0) { var m = drag.moved; drag = null; if (m) suppressZoomClick = true; /* svälj efterföljande click efter panorering */ }
      if (swipe) {
        var dx = e.clientX - swipe.x, dy = e.clientY - swipe.y, dt = Date.now() - swipe.t;
        swipe = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && dt < 800) { go(dx < 0 ? 1 : -1); }
      }
    }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
    stage.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && scale === 1) return;
      e.preventDefault();
      setZoom(Math.min(4, Math.max(1, scale - e.deltaY * 0.01)), tx, ty);
    }, { passive: false });
  }
  function setZoom(s, x, y) {
    scale = s;
    if (s === 1) { x = 0; y = 0; }
    else if (img && img.clientWidth) { var mx = (s - 1) * img.clientWidth / 2, my = (s - 1) * img.clientHeight / 2; x = Math.max(-mx, Math.min(mx, x)); y = Math.max(-my, Math.min(my, y)); }
    tx = x; ty = y;
    img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    img.classList.toggle('is-zoomed', scale > 1);
  }
  function stopVideo() {
    if (!vid) return;
    var v = vid.querySelector('video'); if (v) { try { v.pause(); } catch (err) {} }
    vid.innerHTML = ''; vid.hidden = true;
  }
  function show(i) {
    if (!items.length) return;
    idx = (i + items.length) % items.length;
    setZoom(1, 0, 0);
    stopVideo();
    var it = items[idx];
    if (it.type === 'video') {
      lb.classList.add('wf-lb--video');
      img.hidden = true; img.removeAttribute('src');
      vid.innerHTML = it.html;
      vid.hidden = false;
      var v = vid.querySelector('video');
      if (v) { v.setAttribute('controls', ''); v.setAttribute('playsinline', ''); v.muted = false; v.autoplay = true; try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (err) {} }
      var fr = vid.querySelector('iframe');
      if (fr && /youtube|vimeo/.test(fr.src) && fr.src.indexOf('autoplay=') < 0) { fr.src += (fr.src.indexOf('?') < 0 ? '?' : '&') + 'autoplay=1'; }
    } else {
      lb.classList.remove('wf-lb--video');
      vid.hidden = true;
      img.hidden = false;
      /* frilagda/transparenta bilder får vit botten (kundregel 2026-09-17): kolla alfa via canvas, annars filändelse */
      img.classList.remove('wf-lb__img--white');
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        if (img.src !== it.src) return;
        var white = /\.(png|webp|gif|avif)(\?|$)/i.test(it.src);
        try {
          var c = document.createElement('canvas'), w = 48, hgt = 48; c.width = w; c.height = hgt;
          var g = c.getContext('2d'); g.drawImage(img, 0, 0, w, hgt);
          var d = g.getImageData(0, 0, w, hgt).data, t = 0, n = 0;
          for (var y = 0; y < hgt; y++) for (var x = 0; x < w; x++) { if (x > 1 && x < w - 2 && y > 1 && y < hgt - 2) continue; n++; if (d[(y * w + x) * 4 + 3] < 250) t++; }
          white = t / n > 0.05;
        } catch (err) {}
        img.classList.toggle('wf-lb__img--white', white);
      };
      img.src = it.src;
      img.alt = it.alt;
    }
    cnt.textContent = (idx + 1) + ' / ' + items.length;
    thumbs.querySelectorAll('[data-wf-lb-idx]').forEach(function (t, k) {
      var on = k === idx; t.classList.toggle('is-on', on); t.setAttribute('aria-current', on ? 'true' : 'false');
      if (on) { try { t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (err) {} }
    });
    lb.classList.toggle('wf-lb--single', items.length < 2);
    /* förladda grannarna */
    [idx + 1, idx - 1].forEach(function (k) { var n = items[(k + items.length) % items.length]; if (n && n.type === 'image') { var p = new Image(); p.src = n.src; } });
  }
  function go(d) { show(idx + d); }
  function open(root, startId) {
    if (!lb) build();
    items = collect(root);
    if (!items.length) return;
    gallerySection = root.getAttribute('data-section') || '';
    thumbs.innerHTML = items.map(function (it, k) { return '<button type="button" class="wf-lb__thumb' + (it.type === 'video' ? ' wf-lb__thumb--video' : '') + '" data-wf-lb-idx="' + k + '" role="listitem" aria-label="' + T[3] + ' ' + (k + 1) + '">' + (it.thumb ? '<img src="' + it.thumb.replace(/([?&])width=\d+/, '$1width=160') + '" alt="" loading="lazy">' : '') + (it.type === 'video' ? '<span class="wf-lb__play" aria-hidden="true"></span>' : '') + '</button>'; }).join('');
    var start = 0;
    items.forEach(function (it, k) { if (startId && it.id === startId) start = k; });
    lastFocus = document.activeElement;
    lb.hidden = false;
    document.documentElement.classList.add('wf-lb-open');
    show(start);
    requestAnimationFrame(function () { lb.classList.add('is-in'); lb.querySelector('.wf-lb__close').focus(); });
  }
  function close() {
    if (!lb || lb.hidden) return;
    lb.classList.remove('is-in');
    stopVideo();
    document.documentElement.classList.remove('wf-lb-open');
    var mg = document.querySelector('.wf-pdp media-gallery');
    var it = items[idx];
    if (mg && it && it.id && mg.setActiveMedia) { try { mg.setActiveMedia(it.id, false); } catch (err) {} }
    setTimeout(function () { lb.hidden = true; img.removeAttribute('src'); }, 220);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (err) {} }
  }
  /* ta över Sense modal-opener + zoomknapp i galleriet (capture, innan temats JS) */
  document.addEventListener('click', function (e) {
    var root = e.target.closest('.wf-pdp');
    if (!root) return;
    var opener = e.target.closest('.product__modal-opener--image, .product__media-toggle');
    if (!opener) return;
    var li = opener.closest('.product__media-item');
    if (li && li.querySelector('product-model')) return; /* 3D: temats vy */
    e.preventDefault();
    e.stopImmediatePropagation();
    open(root, li ? li.getAttribute('data-media-id') : '');
  }, true);
})();

/* wf-gallery-arrows – pilar över huvudbilden på DATOR (≥750 px) för att bläddra till nästa/föregående bild (kundönskemål 2026-09-18).
   Mobilen har temats egna slider-knappar. Byter aktiv bild via media-gallery.setActiveMedia (samma som ett tumnagelklick), följer
   tumnaglarnas ordning och hoppar över dolda (variantfiltrerade) bilder. Piltangenter fungerar när fokus ligger i galleriet. */
(function () {
  if (window.wfGalArrows) return;
  window.wfGalArrows = 1;
  var mq = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
  var I18N = { sv: ['Föregående bild', 'Nästa bild'], en: ['Previous image', 'Next image'], fr: ['Image précédente', 'Image suivante'], es: ['Imagen anterior', 'Imagen siguiente'], de: ['Vorheriges Bild', 'Nächstes Bild'], it: ['Immagine precedente', 'Immagine successiva'] };
  var lang = (document.documentElement.lang || 'sv').slice(0, 2).toLowerCase();
  var T = I18N[lang] || I18N.sv;
  function init() {
    var gal = document.querySelector('.wf-pdp media-gallery');
    if (!gal || gal.querySelector('.wf-gal__arrow')) return;
    var viewer = gal.querySelector('[id^="GalleryViewer"]');
    var thumbs = gal.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbs) return;
    function ids() {
      return Array.prototype.filter.call(thumbs.querySelectorAll('[data-target]'), function (t) { return !t.hidden && t.offsetParent !== null; }).map(function (t) { return t.getAttribute('data-target'); });
    }
    function current() {
      var cur = thumbs.querySelector('[data-target] button[aria-current]');
      if (cur) return cur.closest('[data-target]').getAttribute('data-target');
      var act = viewer.querySelector('[data-media-id].is-active') || viewer.querySelector('[data-media-id]');
      return act ? act.getAttribute('data-media-id') : null;
    }
    function go(d) {
      var list = ids(); if (list.length < 2) return;
      var i = list.indexOf(current()); if (i < 0) i = 0;
      var next = list[(i + d + list.length) % list.length];
      if (typeof gal.setActiveMedia === 'function') gal.setActiveMedia(next, false);
      else { var b = thumbs.querySelector('[data-target="' + next + '"] button'); if (b) b.click(); }
    }
    function mk(cls, label, d, path) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'wf-gal__arrow ' + cls; b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '"/></svg>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(d); });
      return b;
    }
    viewer.appendChild(mk('wf-gal__arrow--prev', T[0], -1, 'M15 5l-7 7 7 7'));
    viewer.appendChild(mk('wf-gal__arrow--next', T[1], 1, 'M9 5l7 7-7 7'));
    function sync() { var n = ids().length; viewer.classList.toggle('wf-gal--multi', n > 1 && (!mq || mq.matches)); }
    sync();
    if (mq && mq.addEventListener) mq.addEventListener('change', sync);
    document.addEventListener('variant:change', sync); document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) setTimeout(sync, 300); });
    gal.addEventListener('keydown', function (e) {
      if (!mq || !mq.matches) return;
      if (e.target.closest && e.target.closest('input, select, textarea')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); } else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('media-gallery').then(init).catch(function () {});
})();
